import { createClient } from '@supabase/supabase-js';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import { supabase } from '../utils/supabase/client';
import { useAuth } from './AuthProvider';



export const useNotifications = () => {
  const {profile} = useAuth(); 

  return useQuery({
    queryKey: ['notifications'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('notifications')
        .select('*').eq("restaurantid",profile.restaurantid);
      if (error) throw error;

      // Ensure name and status are never null
      return data; 
    },
    enabled: !!supabase.auth.getSession(),
  });
};


export const useDeleteNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ notificationId }) => {
      const { error } = await supabase
        .from('notifications')
        .delete()
        .eq('id', notificationId);
      if (error) throw error;
      return { id: notificationId }; // Return the ID for invalidation
    },
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};


export const useAddNotification = () => {
  const queryClient = useQueryClient();
    const {profile} = useAuth(); 


  return useMutation({
    mutationFn: async ({title,text }) => {
      const { data, error } = await supabase
        .from('notifications')
        .insert([{title,text,restaurantid:profile.restaurantid}])
        .select('*');
      if (error) throw error;
      return data[0];
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};